/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Practice_View_SummaryInputs */

const en_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`View Summary`)
};

const de_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung anzeigen`)
};

const fr_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voir le résumé`)
};

const es_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ver resumen`)
};

const it_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vedi riepilogo`)
};

const nl_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samenvatting bekijken`)
};

const pl_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podsumowanie`)
};

const fi_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Näytä yhteenveto`)
};

const da_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se opsummering`)
};

const sv_interview_practice_view_summary = /** @type {(inputs: Interview_Practice_View_SummaryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Visa sammanfattning`)
};

/**
* | output |
* | --- |
* | "View Summary" |
*
* @param {Interview_Practice_View_SummaryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_practice_view_summary = /** @type {((inputs?: Interview_Practice_View_SummaryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Practice_View_SummaryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_practice_view_summary(inputs)
	if (locale === "fr") return fr_interview_practice_view_summary(inputs)
	if (locale === "es") return es_interview_practice_view_summary(inputs)
	if (locale === "it") return it_interview_practice_view_summary(inputs)
	if (locale === "nl") return nl_interview_practice_view_summary(inputs)
	if (locale === "pl") return pl_interview_practice_view_summary(inputs)
	if (locale === "fi") return fi_interview_practice_view_summary(inputs)
	if (locale === "da") return da_interview_practice_view_summary(inputs)
	if (locale === "sv") return sv_interview_practice_view_summary(inputs)
	return en_interview_practice_view_summary(inputs)
});